import type { IArticle, IAuthor } from "~/types";
import type { IArticleSchema } from "~/types/models/Article.model";
import type { IAuthorSchema } from "~/types/models/Author.model";
import { deriveImageOrientation } from "~/helpers/deriveImageOrientation";

function mapArticleAuthor(author: IAuthorSchema): IAuthor {
  return {
    userId: author.UserId,
    fullName: author.FullName,
    affiliations: author.Affiliations?.map((affiliation) => ({
      department: affiliation.Department ?? undefined,
      organization: affiliation.Organization,
      city: affiliation.City || undefined,
      country: affiliation.Country
    }))
  };
}

function mapIArticleSchemaToIArticle(article: IArticleSchema): IArticle {
  const impact = article.ImpactV5;
  const section = article.Section
    ? { sectionId: article.Section.SectionId }
    : undefined;
  const image = article.Image
    ? {
        url: article.Image.Url,
        width: article.Image.Width,
        height: article.Image.Height,
        orientation:
          article.Image.Orientation ??
          deriveImageOrientation(article.Image.Width, article.Image.Height)
      }
    : undefined;
  return {
    id: article.ArticleId,
    doi: article.DOI,
    abstract: article.Abstract,
    bodyText: article.BodyText,
    fieldCode: article.FieldCode,
    title: article.Title,
    articleType: article.ArticleType?.Name,
    publishedOn: article.PublishedDate && String(article.PublishedDate),
    recentDate: String(article.RecentDate),
    receivedDate: article.ReceivedDate,
    acceptedDate: article.AcceptedDate,
    isPublished: article.Published,
    authors: article.Authors?.map(mapArticleAuthor),
    impactV5: {
      views: impact?.Views,
      downloads: impact?.Downloads,
      citations: impact?.Citations,
      viewsAndDownloads: impact?.ViewsAndDownloads
    },
    journal: {
      journalId: article.Journal.JournalId,
      journalSlug: article.Journal.JournalSlug
    },
    section: section,
    imageUrl: article.ImageUrl ?? article.Image?.Url,
    score: article.Score,
    image
  };
}

export { mapIArticleSchemaToIArticle };
